import {JSX} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {useState, useEffect} from "react";
import {Base64} from "js-base64";
import {isLoggedIn} from "../../services/authService";
import endpoints from "../../api/endpoints";
import LoadingBars from "../../components/loadingBars";

function Login(): JSX.Element {
  const [credentials, setCredentials] = useState({username: "", password: ""});
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    useEffect(() => {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        if (!clientId) return;

        const scriptId = 'google-identity-script';
        if (document.getElementById(scriptId)) return;

        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            // @ts-ignore
            if (window.google && window.google.accounts && window.google.accounts.id) {
                // @ts-ignore
                window.google.accounts.id.initialize({
                    client_id: clientId,
                    callback: handleCredentialResponse,
                });
                // @ts-ignore
                window.google.accounts.id.renderButton(
                    document.getElementById('googleSignInDiv'),
                    { theme: 'outline', size: 'medium' }
                );
            }
        };

        document.head.appendChild(script);

        return () => {
            const s = document.getElementById(scriptId);
            if (s) s.remove();
        };
    }, []);

    useEffect(() => {
        if (isLoggedIn()) {
            window.location.replace("/featured-list");
        }
    }, []);
  
  // response.credential contains the ID token (JWT) from Google
  const handleCredentialResponse = async (response: any) => {
    if (!response || !response.credential) {
      console.error('No credential returned from Google');
      return;
    }

    const idToken = response.credential;
    setIsLoggingIn(true);

    try {
      const code = process.env.REACT_APP_AZURE_KEY || '';
      // POST the Google ID token to your backend. Adjust query param clientId as backend expects.
      const res = await fetch(`${endpoints.auth.login_check_api}?clientId=google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-functions-key': code
        },
        body: JSON.stringify({ credential: idToken })
      });

      if (res.status === 200) {
        const data = await res.json();
        localStorage.setItem('user', JSON.stringify(data));
        window.location.replace('/featured-list/watching');
      } else {
        const text = await res.text();
        console.error('Google login failed', res.status, text);
        alert('Google login failed');
      }
    } catch (err) {
      console.error(err);
      alert('Google login error');
    } finally {
      setIsLoggingIn(false);
    }
  }

const handleUsernameChange = (ev: any) => {
    setCredentials((prevState) => {
      return {
        ...prevState,
        username: ev.target.value
      }
    })
  }

  const handlePasswordChange = (ev: any) => {
    setCredentials((prevState) => {
      return {
        ...prevState,
        password: ev.target.value
      }
    })
  }

  const hasCredentials = () => {
      const keys = Object.keys(credentials);
      return keys.includes("username") && keys.includes("password");
  }

  const handleLogin = async (ev: any) => {
      // Prevent the browser from reloading the page
      ev.preventDefault();

      if (!hasCredentials()) {
          alert("Please fill in a username and password");
          return;
      }

      const code = process.env.REACT_APP_AZURE_KEY;

      if (!code) {
          console.error("No code in env file!");
          return;
      }

      const basicAuth = "Basic " + Base64.encode(`${credentials.username}:${credentials.password}`);
      setIsLoggingIn(true);
      try {
         await fetch(`${endpoints.baseUrl}/api/v2/login_check?clientId=default`, {
              method: "POST",
              headers: {
                  "Authorization": basicAuth,
                  "x-functions-key": code
              }
          })
         .then((data) => {
             if (data.status && data.status === 200) {
                 data.json().then((res) => {
                     localStorage.setItem("user", JSON.stringify(res));
                     window.location.replace("/featured-list/watching");
                     setIsLoggingIn(false);
                 })
             } else {
                 alert("Credentials are false!");
                 setIsLoggingIn(false);
             }

         })
         .catch((error) => {
             console.error(error);
             setIsLoggingIn(false);
         });
      } catch (error) {
          console.error(error);
      }
  }

  return (
      <>
          <h1 className="h3 mb-3 font-weight-normal align-content-center"><i className="fas fa-sign-in-alt"></i> Log in</h1>
          <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3" controlId="loginForm.username">
                  <Form.Label>Username</Form.Label>
                  <Form.Control type="text" onChange={handleUsernameChange} disabled={isLoggingIn}/>
              </Form.Group>
              <Form.Group className="mb-3" controlId="loginForm.password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" onChange={handlePasswordChange} disabled={isLoggingIn}/>
              </Form.Group>
              <Button variant="primary" type="submit" disabled={isLoggingIn}>Log in</Button>
              <div
                id="googleSignInDiv"
                style={{
                  display: 'inline-block',
                  marginLeft: '10px',
                  position: 'relative',
                  top: '12px',
                  pointerEvents: isLoggingIn ? 'none' : 'auto',
                  opacity: isLoggingIn ? 0.6 : 1,
                  cursor: isLoggingIn ? 'not-allowed' : 'pointer'
                }}
                aria-disabled={isLoggingIn}
              />
              <LoadingBars isLoading={isLoggingIn}/>
          </Form>
      </>
  );
}

export default Login;
